import { lazy } from 'react';

export const List = lazy(() => import('./list'));
